import { Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  CanDeactivate,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationProvider } from '@nrwl/navigation-abstract';
import { RootParametersProvider } from '../../values.exchange/root.parameters.provider';
import { ValuesExchangeProvider } from '../../values.exchange/values.exchange.provider';

@Injectable({
  providedIn: 'root'
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ClearParamsGuard implements CanDeactivate<any> {
  constructor(
    readonly router: Router,
    readonly navigator: NavigationProvider,
    readonly rootParams: RootParametersProvider,
    readonly valuesExchange: ValuesExchangeProvider
  ) {}

  canDeactivate(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    route: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | boolean | UrlTree {
    return true;
  }
}
